var ListViewAppointmentsWS = require("./ListViewAppointmentsWS");
var FastXMLParser = require("fast-xml-parser");

/**
 * An "improved" Appointments WS capable of parsing larger XML documents.
 * @param {View} parentView
 */

function createLargeListViewAppointmentsWS(parentView, moment) {
  var processor = {

    name: "LargeListViewAppointmentsWS",

    // Use deferred updates for appointments
    // appointments: ko.observableArray([]).extend({ deferred: true }),

    // Over-ride - ensures that the ancestor AbstractWS doesn't give us an XML object
    dataType: "text",

    // Map of Appointment IDs to index in `this.appointments` observable.
    appointmentIndex: {},

    /**
     * @type {{appointments: Array, models: Array, batchSize: number, delay: number}}
     */
    processDataState: {
      isProcessing: false,
      appointments: [],
      models: [],
      batchSize: 2,
      delay: 0
    },

    /**
     * Removes unwanted characters from the XML data
     *
     * @param text {string} XML data as plain text
     * @return {string}
     */
    sanitiseXml: function(text) {
      // Remove NULL characters
      return text.replace(/\0/, "").trim();
    },

    parseXml: function (text) {
      var parser =  FastXMLParser;
      var isValid = parser.validate(this.sanitiseXml(text));

      if (!isValid) {
        throw new Error("Invalid XML");
      }

      var json = parser.parse(text, {
        attributeNamePrefix: "",
        ignoreAttributes: false,
        textNodeName: "text",
      });

      return json;
    },

    /**
     * processData
     *
     * @param {string} data JSON data 
     */
    processData: function(data) {
      if (this.processDataState.isProcessing === true) {
        // We are already working, do nothing.
        return
      }

      var json = this.parseXml(data); 

      var appointmentsData = [];
      if (json.AppointmentsHeaders && json.AppointmentsHeaders.appointments) {
        appointmentsData = json.AppointmentsHeaders.appointments;
      }

      this.processDataState.isProcessing = true;
      this.processDataState.appointments = [];
      this.processDataState.models = [];
      this.appointmentIndex = {};

      if (appointmentsData) {
        this.processDataState.appointments = Array.isArray(
          appointmentsData
        )
          ? appointmentsData
          : [appointmentsData];
      }

      setTimeout(
        function() {
          this.processDataBatch();
        }.bind(this)
      );

      return this;
    },

    clearProcessDataState: function() {
      this.processDataState.models = [];
      this.processDataState.appointments = [];
      this.processDataState.isProcessing = false;
    },

    loadAppointmentModels: function(appointmentsData) {
      return appointmentsData.reduce(function(models, data) {
        if (data && data !== "") {
          models.push(this.createAppointment(data));
        }
        return models;
      }.bind(this), []);
    },

    /**
     * Process the Appointment data, a few items at a time, asynchronously.
     */
    processDataBatch: function() {
      var isProcessingComplete = this.processDataState.appointments.length <= 0;

      if (isProcessingComplete) {
        // this.parent.setStatusMessage("FlexAppointments loaded");

        var nativeArray = [];
        Array.prototype.push.apply(nativeArray, this.processDataState.models);

        this.appointmentIndex = this.processDataState.models.reduce(function (idIndex, currentModel, currentIndex) {
          idIndex[currentModel.id] = currentIndex;
          return idIndex;
        }, {})

        // Clear existing Appointments
        // Ideally we would be able to update only those that needed to be updated
        this.appointments.removeAll();

        this.appointments.push.apply(
          this.appointments,
          this.processDataState.models
        );

        // ko.tasks.runEarly();

        // this.parent.setStatusMessage("FlexAppointments received", 1000);
        this.clearProcessDataState();
        return;
      }

      // this.parent.setStatusMessage("Requesting FlexAppointments");

      // Push the new models
      Array.prototype.push.apply(
        this.processDataState.models,
        this.loadAppointmentModels(
          this.processDataState.appointments.splice(
            0,
            this.processDataState.batchSize
          )
        )
      );

      // Continue processing...
      setTimeout(
        function() {
          this.processDataBatch();
        }.bind(this)
      );
    },

    /**
     * Get an Appointment by ID 
     * @param {string} id 
     * @return {AppointmentModel}
     */
    getAppointment: function (id) {
      var index = this.appointmentIndex[id];
      return (index) ? this.appointments()[index] : undefined;
    },

    /**
     * Sets an appointment's status in the raw collection of appointments
     *
     * @method setAppointmentStatus
     * @param {Number} appointmentId
     * @param {String} newStatus
     * @return {LargeAppointmentsWS}
     */
    setAppointmentStatus: function (appointmentId, newStatus) {
      var appointment = (appointmentId) ? this.getAppointment(appointmentId) : null;
      if (appointment && newStatus) {
        appointment.updateStatus(newStatus);
      }

      return this;
    }
  };

  // Construct
  var LargeListViewAppointmentsWS = Object.create(ListViewAppointmentsWS.prototype);
  // Because AppointmentsWS is observable, many of it's properties are on the object, not it's prototype.
  // So we must remember to apply the constructor Fn.
  ListViewAppointmentsWS.call(LargeListViewAppointmentsWS, parentView, moment);
  // Over-ride it and assign our new properties
  Object.assign(LargeListViewAppointmentsWS, processor);

  return LargeListViewAppointmentsWS;
}

module.exports.createLargeListViewAppointmentsWS = createLargeListViewAppointmentsWS;
